import {styled, Typography} from '@mui/material';

export const TalkingPointHeading = styled(Typography)(({theme}) => ({
  fontSize: '1rem',
  fontWeight: '900',
  lineHeight: '1.3em',
  letterSpacing: 0,
  marginBottom: theme.typography.pxToRem(12),
}));
